// import { searchStateData } from '../../data/searchStateData'
import './style.scss'
import { InstructorSearchResultProfile } from '../../server/types';
import SearchResultProfile from '../../components/searchResultProfile/SearchResultProfile';
import { useAppSelector } from '../../redux/hooks';
import { PAGE_URLS } from '../../constants/hrefLinks';
import AdBannerHome from '../../components/adBannerHome/AdBannerHome';

function SearchResultGrid() {
	const resultProfiles = useAppSelector((state) => state.search.resultProfiles)
	const isLoggedIn = useAppSelector(state => state.user.isLoggedIn)

	return (
		<div className='section-content section-content-reduced-padding'>
			{isLoggedIn == false &&
				<AdBannerHome 
					onClick={() => {
						window.location.replace(`${PAGE_URLS.SIGN_UP}`)
					}}
				/>
			}
			<div className="profile-grid-wrap">
				{resultProfiles?.map((profile: InstructorSearchResultProfile, index: number) => 
					<SearchResultProfile 
						profile={profile} 
						key={`profile-grid${index}`}
					/>
				)}
			</div>
		</div>
	)
}

export default SearchResultGrid
